<template>
  <div class="post py-3" style="max-width: 350px;">
    <div class="post-thumbnail">
      <div style="cursor: pointer;max-height: 300px;overflow: hidden;" @click="handleTitleClick()">
        <img style="width: 100%; max-height: 250px;" class="img-fluid" :src="initialData.fragments.imgSrc"
          :alt="initialData.fragments.title">
      </div>
    </div>
    <div class="post-details">
      <div class="post-meta d-flex row justify-content-start">
        <b-col class="col-md-5 pt-2">
          <h6 class="card-subtitle text-muted">
            <b-icon icon="calendar2-event"></b-icon>
            {{ initialData.fragments.eventDate }}
          </h6>
        </b-col>
        <b-col class="col-md-3 pt-2">
          <h6 class="card-subtitle text-muted">
            <b-icon icon="stopwatch"></b-icon>
            {{ initialData.fragments.eventTime }}
          </h6>
        </b-col>
        <b-col class="col-md-4 pt-2">
          <h6 v-if="initialData.fragments.price !== '0'" class="card-subtitle text-muted">
            <b-icon icon="cash"></b-icon>
            {{ initialData.fragments.price }}
          </h6>
          <h6 v-else class="card-subtitle text-muted">
            <b-icon icon="cash"></b-icon>
            free
          </h6>
        </b-col>
        <b-col class="col-md-12 pt-2">
          <h6 v-if="!initialData.fragments.venue.virtual" class="card-subtitle text-muted">
            <b-icon icon="geo-alt"></b-icon>
            {{ initialData.fragments.venue.city }} / {{ initialData.fragments.venue.country }}
          </h6>
          <h6 v-else class="card-subtitle text-muted text-truncate">
            <b-icon icon="geo-alt"></b-icon>
            <b-link :href="initialData.fragments.venue.virtual">
              {{ initialData.fragments.venue.virtual }}
            </b-link>
          </h6>
        </b-col>
        <b-row>
        </b-row>
      </div>
      <div style="cursor: pointer; padding: 1px;" @click="handleTitleClick()">
          <h1 style="font-size: 2rem;" class="text-primary">{{ initialData.fragments.title }}</h1>
      </div>
      <h2 style="font-size: 1rem;" class="text-muted">{{ initialData.fragments.intro }}</h2>
      <div style="cursor: pointer; font-size: 0.75rem;"
        class="text-primary" @click="handleTitleClick()">
        Mehr lesen<b-icon icon="arrow-right"></b-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gl-event-listed-medium',
  version: '0.0.1',
  props: {
    initialData: {
      type: Object,
      required: true,
      default: () => {}
    }, // initialData
    listIndex: {
      type: Number,
      required: true,
      default: 0
    } // listIndex
  }, // props
  data () {
    return {
      formData: {}
    }
  }, // data
  components: {}, // components
  /* ----- vuejs hooks ----- */
  mounted () {}, // mounted
  computed: {}, // computed
  watch: {}, // watch
  methods: {
    /* ----- handler methods ----- */
    handleTitleClick () {
      this.$emit('event-listed-selected', this.listIndex)
    }, // handleTitleClick
    /* ----- helper methods ----- */
    formatDate (date) {
      return (new Date(date)).toLocaleDateString()
    }, // formatDate
  } // methods
}
</script>

<style lang="css" scoped>
</style>
